import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { customerService } from "../services/customer.service";

export const createCustomer = createAsyncThunk("createCustomer", async (data, { rejectWithValue }) => {
    try {
        return await customerService.createCustomer(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getCustomerList = createAsyncThunk("getCustomerList", async (params, { rejectWithValue }) => {
    try {
        return await customerService.getCustomerList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getCustomer = createAsyncThunk("getCustomer", async (id, { rejectWithValue }) => {
    try {
        return await customerService.getCustomer(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateCustomer = createAsyncThunk("updateCustomer", async ({data, id}, { rejectWithValue }) => {
    try {
        return await customerService.updateCustomer(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deleteCustomer = createAsyncThunk("deleteCustomer", async (id, { rejectWithValue }) => {
    try {
        return await customerService.deleteCustomer(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

const customerSlice = createSlice({
    name: "pmo-customer",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
    },
    reducers: {
        resetStateCustomer: (state) => {
            state.list.isError = false;
            state.list.message = null;
            state.detail.isError = false;
            state.detail.message = null;
            state.create.isError = false;
            state.create.message = null;
            state.create.data = null;
            state.update.isError = false;
            state.update.message = null;
            state.update.data = null;
            state.delete.isError = false;
            state.delete.message = null;
            state.delete.data = null;
        },
    },
    extraReducers: (builder) => {
        // get customer list
        builder.addCase(getCustomerList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getCustomerList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getCustomerList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get customer detail
        builder.addCase(getCustomer.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getCustomer.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getCustomer.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create customer
        builder.addCase(createCustomer.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createCustomer.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createCustomer.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // update customer
        builder.addCase(updateCustomer.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updateCustomer.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updateCustomer.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete customer
        builder.addCase(deleteCustomer.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deleteCustomer.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deleteCustomer.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });
    },
});

export default customerSlice.reducer;
export const { resetStateCustomer } = customerSlice.actions;

